import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEnglish from './english/en.json'
import translationSpanish from './spanish/es.json'

const resources = {
  en: {
    translation: translationEnglish
  },
  es: {
    translation: translationSpanish
  }
}

const detectedLanguage = navigator.language.split(/[-_]/)[0]

i18next.use(initReactI18next).init({
  resources,
  lng: detectedLanguage ?? 'en'
})

export default i18next
